import React from "react";
import { Box, Typography, Breadcrumbs, Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

// Content-area header: optional title (usually the title lives in the top bar
// now, so this is mostly used for subtitle + actions + breadcrumbs), an
// optional subtitle, breadcrumb trail, and a right-aligned actions slot.
const PageHeader = ({ title, subtitle, breadcrumbs, actions }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        alignItems: "center",
        justifyContent: "space-between",
        mb: 2.5,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        {breadcrumbs?.length > 0 && (
          <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
            {breadcrumbs.map((c, i) =>
              c.to ? (
                <MuiLink
                  key={i}
                  component={RouterLink}
                  to={c.to}
                  underline="hover"
                  color="text.secondary"
                >
                  {c.label}
                </MuiLink>
              ) : (
                <Typography key={i} color="text.secondary" fontSize={13}>
                  {c.label}
                </Typography>
              )
            )}
          </Breadcrumbs>
        )}
        {title && (
          <Typography variant="h3" fontWeight={700}>
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>{actions}</Box>
      )}
    </Box>
  );
};

export default PageHeader;
